import React from 'react';
import { Link } from 'react-router-dom';
import { Eyebrow, sectionTitleClass, splitTextPaddingClass } from './ui';
import Picture from './Picture';

const cellLabelClass = 'mb-1.5 text-[11px] uppercase tracking-[0.08em] text-gray-400';
const cellValueClass = 'text-[28px] font-extrabold tracking-[-0.02em] lg:text-[30px]';

const Airfield: React.FC = () => {
  return (
    <section id="flugplatz" className="bg-gray-900 text-white lg:grid lg:grid-cols-2">
      <div className={`${splitTextPaddingClass} py-10 lg:py-16`}>
        <Eyebrow dark>Flugplatz</Eyebrow>
        <h2 className={`${sectionTitleClass} mb-3 lg:mb-4`}>Flugplatzdaten</h2>
        <p className="mb-6 text-base leading-normal text-gray-300 lg:mb-7 lg:max-w-[44ch] lg:text-[17px]">
          Hier finden Sie alle wichtigen Informationen zu unserem Flugplatz in Bad Langensalza.
        </p>

        <dl className="grid grid-cols-2 border-t border-white/25 lg:max-w-[560px] lg:grid-cols-3">
          <div className="border-b border-r border-white/25 py-4 pr-3 lg:border-b-0 lg:py-[18px] lg:pr-4">
            <dt className={cellLabelClass}>Kennung</dt>
            <dd className={cellValueClass}>EDEB</dd>
          </div>
          <div className="border-b border-white/25 py-4 pl-3.5 lg:border-b-0 lg:border-r lg:px-4 lg:py-[18px]">
            <dt className={cellLabelClass}>
              Frequenz <span className="normal-case">(MHz)</span>
            </dt>
            <dd className={cellValueClass}>125,365</dd>
          </div>
          <div className="col-span-2 border-b border-white/25 py-4 lg:col-span-1 lg:border-b-0 lg:py-[18px] lg:pl-4">
            <dt className={cellLabelClass}>Koordinaten</dt>
            <dd className="text-xl font-semibold lg:text-[15px] lg:leading-[1.4]">
              <span className="lg:block">E 10° 37.30'</span>
              <span className="lg:hidden"> / </span>
              <span className="lg:block">N 051° 07.75'</span>
            </dd>
          </div>
        </dl>

        <p className="mb-4 mt-5 text-sm leading-[1.55] text-gray-300 lg:mt-6 lg:max-w-[52ch] lg:text-[15px]">
          Der Flugplatz liegt ca. 3 km nördlich von Bad Langensalza. Anfahrt über die Thamsbrücker Landstraße.
          <br />
          Standort: Thamsbrücker Landstraße 28, 99947 Bad Langensalza
        </p>
        <Link
          to="/flugplatzinfo"
          className="inline-flex min-h-[44px] items-center text-[15px] font-semibold text-blue-300 transition-colors hover:text-white"
        >
          → Detaillierte Informationen für UL Piloten
        </Link>
      </div>

      <div className="relative hidden min-h-[480px] lg:block">
        <Picture
          src="/images/Flugsportverein_Bilder_9.jpg"
          alt="Ultraleichtflugzeug über einer Wolkendecke"
          sizes="1340px"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
    </section>
  );
};

export default Airfield;
